import React from "react";
import { Crown, Lock } from "lucide-react";

const GREEN = "#00FF87";

// Banner stato prova/abbonamento sulla Home.
// - Pro attivo  -> nessun banner.
// - In prova    -> promemoria discreto con giorni rimasti + "Abbonati".
// - Scaduto     -> banner prominente "Sblocca Liqo Pro".
export const TrialBanner = ({ subscription, onUpgrade }) => {
  if (!subscription) return null;
  // Abbonato Pro attivo: niente banner.
  if (subscription.is_premium && subscription.status === "active") return null;

  const expired = !subscription.is_premium;
  const daysLeft = subscription.days_left ?? 0;

  if (expired) {
    return (
      <button
        onClick={onUpgrade}
        data-testid="trial-banner-expired"
        className="mb-3 flex w-full items-center gap-3 rounded-[12px] border p-3.5 text-left active:scale-[0.99]"
        style={{ borderColor: `${GREEN}3A`, background: "#0D0D14", boxShadow: `0 0 0 1px ${GREEN}1A` }}
      >
        <span
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] border"
          style={{ borderColor: `${GREEN}55`, color: GREEN }}
        >
          <Lock size={16} />
        </span>
        <span className="flex-1">
          <span className="block text-[13px] font-light text-white/90">Prova terminata — sblocca Liqo Pro</span>
          <span className="caps-tag mt-0.5 block text-white/40">Chat CFO, Fisco, Investimenti e altro</span>
        </span>
        <span className="mono text-[10px] font-medium uppercase tracking-[0.14em]" style={{ color: GREEN }}>
          Sblocca ❯
        </span>
      </button>
    );
  }

  // In prova
  return (
    <button
      onClick={onUpgrade}
      data-testid="trial-banner-active"
      className="mb-3 flex w-full items-center gap-3 rounded-[12px] border border-white/[0.08] bg-[#0D0D14] p-3 text-left hover:bg-white/[0.03] active:scale-[0.99]"
    >
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[7px] border border-white/[0.1]" style={{ color: GREEN }}>
        <Crown size={14} />
      </span>
      <span className="flex-1">
        <span className="block text-[12.5px] font-light text-white/80">
          Prova Liqo Pro · <span className="mono tabular text-white/90">{daysLeft}</span> {daysLeft === 1 ? "giorno" : "giorni"} rimasti
        </span>
      </span>
      <span className="mono text-[10px] font-medium uppercase tracking-[0.14em]" style={{ color: GREEN }}>
        Abbonati
      </span>
    </button>
  );
};
